"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bagnaria": {
    "2b790012": [{
      "hkey": "de06d28e",
      "slug": "bagnaria",
      "name": "Bagnaria",
      "primary": true,
      "skipSearch": false
    }],
    "coriola": [{
      "hkey": "de06d28e",
      "slug": "bagnaria",
      "name": "Bagnaria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;